export default {
  QUOTES: "Quotes",
  QUOTE: "Quote",
};
